import { render } from "./AddPricingRule.vue?vue&type=template&id=3918e7db&ts=true"
import script from "./AddPricingRule.vue?vue&type=script&lang=ts"
export * from "./AddPricingRule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__